import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import SEOHead from "@/components/SEOHead";

const Privacidade = () => {
  return (
    <div className="bg-background min-h-screen">
      <SEOHead
        title="Política de Privacidade | EVK"
        description="Política de privacidade e proteção de dados do website evk.pt."
        canonical="https://evk.pt/privacidade"
      />
      <Navbar />
      <div className="container mx-auto px-6 lg:px-12 pt-28 pb-24 max-w-3xl">
        <h1 className="font-serif text-4xl md:text-5xl text-foreground mb-8">
          Política de Privacidade
        </h1>
        <p className="text-xs text-muted-foreground mb-12">
          Última atualização: Abril 2026
        </p>

        <div className="space-y-8 text-sm text-muted-foreground leading-relaxed">
          <section>
            <h2 className="font-serif text-xl text-foreground mb-3">1. Responsável pelo Tratamento</h2>
            <p>
              A EVK — Thinkers & Makers, com sede em TABpark — Zona Industrial da Taboeira, Lote 27, Fração H1, 3800-055 Aveiro, é a entidade responsável pelo tratamento dos dados pessoais recolhidos através deste website.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-foreground mb-3">2. Dados Recolhidos</h2>
            <p>
              Recolhemos os dados pessoais que nos fornece voluntariamente através dos formulários de contacto e candidatura, incluindo nome, email e mensagem.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-foreground mb-3">3. Finalidade do Tratamento</h2>
            <p>
              Os dados recolhidos são utilizados exclusivamente para responder às suas solicitações, processar candidaturas e melhorar os nossos serviços.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-foreground mb-3">4. Cookies</h2>
            <p>
              Este website utiliza cookies para melhorar a experiência de navegação. Os cookies são pequenos ficheiros de texto armazenados no seu dispositivo que nos ajudam a analisar o tráfego do website e personalizar conteúdos.
            </p>
            <ul className="list-disc list-inside mt-3 space-y-1">
              <li>Cookies essenciais — necessários para o funcionamento do website</li>
              <li>Cookies de análise — ajudam-nos a compreender como os visitantes interagem com o website</li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif text-xl text-foreground mb-3">5. Conservação dos Dados</h2>
            <p>
              Os dados pessoais são conservados durante o período necessário para a finalidade para a qual foram recolhidos, ou conforme exigido por lei.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-foreground mb-3">6. Direitos do Titular</h2>
            <p>
              Nos termos do Regulamento Geral sobre a Proteção de Dados (RGPD), tem direito a aceder, retificar, apagar, limitar o tratamento e portabilidade dos seus dados pessoais. Para exercer estes direitos, contacte-nos através de{" "}
              <a href="mailto:geral@evoke.pt" className="text-accent hover:underline">geral@evoke.pt</a>.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-foreground mb-3">7. Segurança</h2>
            <p>
              Adotamos medidas técnicas e organizativas adequadas para proteger os seus dados pessoais contra acessos não autorizados, perda ou destruição.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-foreground mb-3">8. Contacto</h2>
            <p>
              Para questões relacionadas com a proteção de dados, contacte-nos através de{" "}
              <a href="mailto:geral@evoke.pt" className="text-accent hover:underline">geral@evoke.pt</a>{" "}
              ou pelo telefone +351 234 009 539.
            </p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-border">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft size={16} /> Voltar
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Privacidade;
